<script setup>
defineProps({
  activeStep: {
    type: Number,
    required: true,
  },
});

function getStepClass(stepIndex, activeStep) {
  return activeStep >= stepIndex ? "js-active position-relative" : "";
}
</script>

<template>
  <div class="row">
    <div class="mx-auto my-2 col-12">
      <div class="multisteps-form__progress">
        <button class="multisteps-form__progress-btn" type="button" :class="getStepClass(0, activeStep)">
          <span>Fecha</span>
        </button>
        <button class="multisteps-form__progress-btn" type="button" :class="getStepClass(1, activeStep)">
          <span>Vehiculos</span>
        </button>
        <button class="multisteps-form__progress-btn" type="button" :class="getStepClass(2, activeStep)">
          <span>Finalizar</span>
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.multisteps-form__progress :deep(.multisteps-form__progress-btn:not(.js-active)) {
  color: #adb5bd;
}

.multisteps-form__progress :deep(.multisteps-form__progress-btn:not(.js-active)::before) {
  background-color: #f8f9fa;
}
</style>
